import type { Gender } from './types';

/**
 * Согласование по роду в русском интерфейсе.
 *
 * Это не косметика и не вкусовщина. Русский глагол в прошедшем времени
 * согласуется с родом подлежащего, а половина постоянной тестовой сетки —
 * женщины (Noa и Maya). До этого модуля экран разговора сообщал «Noa положил
 * трубку» и «Maya вышел из звонка»: продукт, который существует ради того,
 * чтобы род собеседника доезжал до перевода, сам ошибался в роде в собственных
 * подписях. Пол участника приходит с каждым звонком (CallParticipant.gender),
 * так что выбирать было из чего.
 *
 * `u` («не указывать» в форме профиля) даёт мужскую форму: в русском она же
 * работает как немаркированная, и другого варианта без переписывания фразы в
 * безличную нет.
 */
export function byGender(gender: Gender, masculine: string, feminine: string): string {
  return gender === 'f' ? feminine : masculine;
}
